import { createModel, RematchDispatch } from '@rematch/core';
import * as sceneService from '../../services/scene.service';
import { PaginationType } from '../../types/CommonTypes';
import { SceneData } from '../../types/SceneData';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'sceneEntity';

export const sceneEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof sceneEntity>) => ({
    async loadById(id, state): Promise<SceneData> {
      try {
        const res = await sceneService.getScene(id);
        const scene = res.data;
        if (scene) {
          this.saves([scene]);
        }
        return scene;
      } catch (e) {
        throw new Error(e);
      }
    },
    async load(params): Promise<{ content?: SceneData[] } & PaginationType> {
      try {
        const res = await sceneService.getScenes({ params });
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async save(payload, state) {
      try {
        let item;
        if (!payload.id) {
          ({ data: item } = await sceneService.createScene(payload));
        } else {
          const entity = state[storeName].ids[payload.id] || {};
          ({ data: item } = await sceneService.updateScene(payload.id, { ...entity, ...payload }));
        }
        this.update(item);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(id) {
      try {
        const res = await sceneService.deleteScene(id);
        if (res && res.data) {
          this.remove({ id });
        }
        return res;
      } catch (e) {
        throw new Error(e);
      }
    },
    async deleteMultiple(ids): Promise<void> {
      try {
        await sceneService.deleteScenes(ids);
        ids.forEach((id) => {
          this.remove({ id });
        });
      } catch (e) {
        throw new Error(e);
      }
    },
    async retry(id) {
      try {
        const item = await sceneService.retryCreateScene(id);
        this.update(item.data);
      } catch (e) {
        throw new Error(e);
      }
    },
    async checkUsage(id) {
      try {
        const { data } = await sceneService.checkSceneUsage(id);
        return data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async updatePano(payload) {
      try {
        const item = await sceneService.updatePano(payload.id, payload);
        this.update(item.data);
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default sceneEntity;
